import { render, staticRenderFns } from "./HomeTopic.vue?vue&type=template&id=2fa865b4&scoped=true"
import script from "./HomeTopic.vue?vue&type=script&lang=js"
export * from "./HomeTopic.vue?vue&type=script&lang=js"
import style0 from "./HomeTopic.vue?vue&type=style&index=0&id=2fa865b4&prod&scoped=true&lang=css"
import style1 from "./HomeTopic.vue?vue&type=style&index=1&id=2fa865b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa865b4",
  null
  
)

export default component.exports